import axios from 'axios';

export default async function login(username, password) {
	let data = null;
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_LAB_API}user/login`,
			data: { username, password },
			headers: { 
				'content-type': 'application/json'
				,'x-client-id': sessionStorage.getItem("clientId")
			}
		});

		data = response;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return data;
}